// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"7c3de12767cbe4757ec5","966":"b8f2916a72ae0db2a529"}[chunkId] + ".js";
};